<template>
  <div class="flex justify-evenly space-x-6">
    <BrandsBrandItem
      v-for="brand in data?.productBrands?.data"
      :selected="props.selectedBrand?.attributes?.name === brand.attributes?.name"
      :key="brand.attributes?.slug"
      :brand="brand"
      @selected="(selectedBrand) => emit('selected', selectedBrand)"
    />
  </div>
</template>
<script setup lang="ts">
import { BrandWithProductsFragment } from "#gql";
import { BrandsKey } from "~/symbols/symbols";

const data = inject(BrandsKey);

const props = defineProps<{
  selectedBrand: BrandWithProductsFragment | null | undefined;
}>();

const emit = defineEmits<{
  (e: "selected", brand: BrandWithProductsFragment | null | undefined): void;
}>();
</script>
<style lang="scss" scoped></style>
